import React, { useState, useEffect } from "react";
import LandingPageDesktop from "./LandingPageDesktop";
import LandingPageMobile from "./LandingPageMobile";

export default function LandingPage() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      // Detecta mobile baseado na largura da tela (até 768px)
      setIsMobile(window.innerWidth <= 768);
    };

    // Verifica no mount
    checkIsMobile();

    // Adiciona listener para mudanças de tamanho
    window.addEventListener('resize', checkIsMobile);

    // Cleanup
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  // Renderiza o componente apropriado baseado no tamanho da tela
  return isMobile ? <LandingPageMobile /> : <LandingPageDesktop />;
}
